// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ArrowNE = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ArrowNE = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ArrowNE = _exports.ArrowNE = function ArrowNE(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M15.8818 3.08008C16.4572 3.08008 16.9201 3.54278 16.9201 4.11792V14.4963C16.9201 15.0714 16.4572 15.5341 15.8818 15.5341C15.3064 15.5341 14.8435 15.0714 14.8435 14.4963V6.6217L4.85003 16.6152C4.44337 17.0217 3.78579 17.0217 3.38345 16.6152C2.98112 16.2087 2.97679 15.5514 3.38345 15.1493L13.3769 5.16008L5.49896 5.15575C4.92357 5.15575 4.46067 4.69305 4.46067 4.11792C4.46067 3.54278 4.92357 3.08008 5.49896 3.08008H15.8818Z",
      fill: "currentColor"
    }));
  };
});
